import { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../assets/images/purelifespan300-1.png';
import licence from '../assets/images/nz_licence.png';
import { lists } from '../resource/NavList';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

export default withRouter(({ location: { pathname } }) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => {
    setOpen(!open);
  };

  const NavList = ({ list }) => (
    <div className="dropdown__nav-item">
      <div className="nav__item-title">
        <Link to={list.direction}>
          <h3>{list.name}</h3>
        </Link>
      </div>
    </div>
  );

  const NavRowList = ({ list }) => {
    const { name, direction } = list;
    return (
      <li
        className="header__nav-item list__item-nobullet"
        current={pathname === { direction }}
      >
        <Link to={direction}>{name}</Link>
      </li>
    );
  };

  return (
    <div className="header full-horizon">
      <div className="header__container full-horizon">
        <div className="row header__space">
          <div className="header__logo">
            <div current={pathname === '/'}>
              <Link to="/">
                <img src={logo} className="logo__image" alt="lifespan logo" />
              </Link>
            </div>
          </div>
          <div className="header__right row">
            <div className="header__nav">
              <div className="header__nav-container">
                <ul className="row header__nav-list">
                  {lists.map((list) => (
                    <NavRowList list={list} key={list.id} />
                  ))}
                </ul>
              </div>
            </div>
            <div className="header__licence">
              <img
                src={licence}
                className="licence__image"
                alt="new zealand licence"
              />
            </div>
          </div>
          <div className="header__navbar">
            <div
              id="openMenu"
              onClick={toggleOpen}
              className="header__navbar-icon"
            >
              <FontAwesomeIcon icon={faBars} />
            </div>
          </div>
        </div>
      </div>
      {open ? (
        <div className="dropdown__nav column">
          <ol>
            {lists.map((list) => (
              <NavList list={list} key={list.id} />
            ))}
          </ol>
          <div className="dropdown__licence">
            <img
              src={licence}
              className="licence__image"
              alt="new zealand licence"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
});
